export default __webpack_public_path__ + "static/media/EK.e64515fb.png";